/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import gatewayLogTemplate from './gateway-log.tpl.html';

/*@ngInject*/
export default function GatewayLogDirective($compile, $templateCache, $translate, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayLogTemplate);
        element.html(template);
        scope.types = types;
        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gatewayLog: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway-log/gateway-log.directive.js